"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "JSONRepairError", {
  enumerable: true,
  get: function () {
    return _JSONRepairError.JSONRepairError;
  }
});
Object.defineProperty(exports, "jsonrepair", {
  enumerable: true,
  get: function () {
    return _jsonrepair.jsonrepair;
  }
});
var _jsonrepair = require("./regular/jsonrepair.js");
var _JSONRepairError = require("./utils/JSONRepairError.js");
//# sourceMappingURL=index.js.map